var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-dialog",
    {
      ref: _vm.dialogRef,
      attrs: { id: "general-form-wrapper", "md-click-outside-to-close": false }
    },
    [
      _c("md-dialog-title", { staticClass: "md-headline" }, [
        _vm._v(_vm._s(_vm.title))
      ]),
      _c(
        "md-dialog-content",
        [
          _c(
            "loader",
            { attrs: { loading: _vm.creating, size: 45 } },
            [_vm._t("default")],
            2
          )
        ],
        1
      ),
      _c(
        "md-dialog-actions",
        { staticClass: "actions" },
        [
          _c(
            "md-button",
            { staticClass: "md-primary", on: { click: _vm.closeDialog } },
            [_vm._v("Cancel")]
          ),
          _c(
            "md-button",
            {
              staticClass: "md-primary md-raised",
              attrs: { disabled: _vm.validationPending },
              on: { click: _vm.save }
            },
            [_vm._v("Create")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f4da7b6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f4da7b6","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/forms/DialogForm.vue
// module id = 763
// module chunks = 0